export default "__VITE_ASSET__Cvnac5PV__"